import { useCallback, useState } from 'react';
export default function useModalVisibility(value, onOpen, onClose) {
    const [isOpen, setModalVisibility] = useState(value);
    const handleOpen = useCallback(() => {
        setModalVisibility(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [onOpen]);
    const handleClose = useCallback(() => {
        setModalVisibility(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    return [isOpen, handleOpen, handleClose];
}
